import { render, staticRenderFns } from "./table-actions.vue?vue&type=template&id=2aedab02&lang=pug&"
import script from "./table-actions.vue?vue&type=script&lang=js&"
export * from "./table-actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports